import { render, staticRenderFns } from "./DesktopOrganization.vue?vue&type=template&id=22aa592d&scoped=true&lang=pug&"
import script from "./DesktopOrganization.vue?vue&type=script&lang=js&"
export * from "./DesktopOrganization.vue?vue&type=script&lang=js&"
import style0 from "./DesktopOrganization.vue?vue&type=style&index=0&id=22aa592d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aa592d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCol,VRow,VSlideYReverseTransition,VTab,VTabs,VTabsSlider})
